const romeAirportCodes = ['FCO', 'CIA'];

export const isTravellingViaRome = (
  segments: {
    origin: { code: string };
    destination: { code: string };
  }[],
) =>
  segments?.some(
    (segment) =>
      romeAirportCodes.includes(segment.destination.code) ||
      romeAirportCodes.includes(segment.origin.code),
  );
